export const GET_ALL_SSO_CONTENT = 'GET_ALL_SSO_CONTENT';
export const GET_ALL_SSO_EVENT = 'GET_ALL_SSO_EVENT';
export const GET_ALL_USER_DATA = 'GET_ALL_USER_DATA';
export const GET_ALL_TRACKING_DATA = 'GET_ALL_TRACKING_DATA';



